import { render, staticRenderFns } from "./ProductLandingPage.vue?vue&type=template&id=4b53daec&scoped=true"
import script from "./ProductLandingPage.vue?vue&type=script&lang=js"
export * from "./ProductLandingPage.vue?vue&type=script&lang=js"
import style0 from "./ProductLandingPage.vue?vue&type=style&index=0&id=4b53daec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b53daec",
  null
  
)

export default component.exports